import React from 'react';
import PropTypes from 'prop-types';
import Map from '../common/Map';

const DevelopmentsMap = ({ developments, forthcoming, error, onMarkerClick }) => (
  <section className="map">
    {error && (
      <div className="container">
        <p>An error occurred while trying to load developments, please try again later.</p>
      </div>
    )}
    <div className="development-map">
      <Map
        markers={
          developments &&
          developments.length &&
          developments.map((d) => ({
            position: {
              lat: Number(d.latitude),
              lng: Number(d.longitude),
            },
            defaultAnimation: 2,
            onClick: () => onMarkerClick(d),
            icon: `/images/${forthcoming ? 'forthcoming' : 'available'}house.png`,
          }))
        }
      />
    </div>
  </section>
);

DevelopmentsMap.propTypes = {
  developments: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number.isRequired,
      name: PropTypes.string.isRequired,
      status: PropTypes.string,
      latitude: PropTypes.number,
      longitude: PropTypes.number,
    })
  ).isRequired,
  forthcoming: PropTypes.bool,
  error: PropTypes.string,
  onMarkerClick: PropTypes.func.isRequired,
};

DevelopmentsMap.defaultProps = {
  forthcoming: false,
  error: '',
};

export default DevelopmentsMap;
